import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { VillaHostSignupButton } from "../villa-host-signup-button";
import { VILLA_HOST_SUPPORT_PHONE_NUMBER } from "../villa-host.constants";
import type { VillaHostImageSource } from "../villa-host.types";
export const VillaHostJoinBanner = t0 => {
  const $ = _c(10);
  const {
    smallImage,
    largeImage
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-base font-semibold max-lg:pt-4 max-lg:text-center">به جمع میزبانان موفق بپیوندید</div>;
    t2 = <p className="text-body-1 pb-6 pt-2 max-lg:text-center lg:w-[70%]">با سرویس میزبانی اسنپ‌تریپ، مدیریت هوشمند رزروها جایگزین دغدغه‌های اجرایی می‌شود تا بستری آماده برای جذب همیشگی مسافر و تجربه درآمدی مطمئن فراهم گردد.</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col pb-6 pt-4 lg:py-16">{t1}{t2}<div className="flex justify-evenly gap-4 lg:justify-start"><VillaHostSignupButton size="large">ثبت نام میزبان</VillaHostSignupButton><Button size="large" color="neutral" variant="outline" role="link" href={`tel:${VILLA_HOST_SUPPORT_PHONE_NUMBER}`}>تماس با پشتیبانی</Button></div></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== smallImage) {
    t4 = <LazyImage alt="" src={smallImage} className="absolute bottom-0 left-[70%] w-[160px] object-contain lg:w-[214px]" />;
    $[3] = smallImage;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== largeImage) {
    t5 = <LazyImage alt="" src={largeImage} className="w-[172px] lg:w-[214px]" />;
    $[5] = largeImage;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className="border-outline-thin relative flex w-full items-center justify-between overflow-visible rounded-3xl border px-6 max-lg:flex-col lg:mt-20 lg:min-h-[190px] lg:pl-64">{t3}<div className="relative flex max-lg:mx-auto max-lg:-translate-x-1/3 max-lg:justify-center lg:absolute lg:bottom-0 lg:left-6">{t4}{t5}</div></div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};